import { FC, useRef } from 'react'
import { useRadio } from '@chakra-ui/react'
import { Box, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import theme from '../../styles'
import { RadioButton } from './radio-button'

export const SmallPillRadioButton: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getRadioProps } = useRadio({ ...props, value: props.value?.toString() })
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <Box as="label" cursor="pointer" data-testid={`pill-${props.value}`}>
      <Box
        {...getRadioProps()}
        display="flex"
        tabIndex={0}
        onFocus={handleFocus}
        aria-label={`button-${props.label}`}
        layerStyle={theme.LayerStyles.SMALL_PILL}
      >
        <RadioButton {...getInputProps()} ref={inputRef} />

        <Text>{props.label}</Text>
      </Box>
    </Box>
  )
}
